/** @jsx jsx */
import { ReactNode } from 'react';
import { jsx } from '@emotion/core';

import VersionModalWrapper from './VersionModalWrapper';

type StatusModalProps = {
  isSuccess: boolean;
  heading: string;
  description: string;
  confirmButtonLabel: string;
  cancelButtonLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
  children?: ReactNode;
};

function Status(props: StatusModalProps) {
  return (
    <VersionModalWrapper
      children={props.children}
      isFailure={!props.isSuccess}
      isSaving={false}
      modalProps={{ closeOnOutsideClick: true }}
      {...props}
    />
  );
}

export default Status;
